import React from 'react';
import { StatusIconProps } from './utils';

function Information({ width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V11Z"
        fill="white"
      />
      <path
        d="M13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9C12.5523 9 13 8.55228 13 8Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM12 10C12.5523 10 13 10.4477 13 11V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V11C11 10.4477 11.4477 10 12 10ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
        fill="#0093CB"
      />
    </svg>
  );
}
Information.propTypes = StatusIconProps;

export default Information;
